import { DomainsActionTypes } from './domains.types';

const getDomainsRequest = page => ({ type: DomainsActionTypes.GET_DOMAINS_REQUEST, payload: page });
const getDomainsSuccess = () => ({ type: DomainsActionTypes.GET_DOMAINS_SUCCESS });
const getDomainsFailure = () => ({ type: DomainsActionTypes.GET_DOMAINS_FAILURE });
const setDomains = list => ({ type: DomainsActionTypes.SET_DOMAINS, payload: list });

const getDomainDetail = id => ({ type: DomainsActionTypes.GET_DOMAIN_DETAIL_REQUEST, payload: { id } });
const getDomainDetailSuccess = () => ({ type: DomainsActionTypes.GET_DOMAINS_SUCCESS });
const getDomainDetailFailure = () => ({ type: DomainsActionTypes.GET_DOMAINS_FAILURE });
const setDomainDetail = detail => ({ type: DomainsActionTypes.SET_DOMAIN_DETAIL, payload: detail });

const getDomainsElegible = () => ({ type: DomainsActionTypes.REQUEST_DOMAINS_ELEGIBLE });
const getDomainsElegibleSuccess = () => ({ type: DomainsActionTypes.DOMAINS_ELEGIBLE_SUCCESS });
const getDomainsElegibleFailure = () => ({ type: DomainsActionTypes.DOMAINS_ELEGIBLE_FAILURE });
const setDomainsElegible = domainsElegible => ({ type: DomainsActionTypes.SET_DOMAINS_ELEGIBLE, payload: domainsElegible });

const domainsActivateRenewalRequest = (domainData, callBackFunction) => ({
  type: DomainsActionTypes.DOMAIN_ACTIVATE_RENEWAL_REQUEST,
  payload: { domainData, callBackFunction },
});

const domainsActivateRenewalSuccess = () => ({
  type: DomainsActionTypes.DOMAIN_ACTIVATE_RENEWAL_SUCCESS,
});

const domainsActivateRenewalFailure = () => ({
  type: DomainsActionTypes.DOMAIN_ACTIVATE_RENEWAL_FAILURE,
});

const domainsGenerateNewInvoiceRequest = (domainData, callBackFunction) => ({
  type: DomainsActionTypes.DOMAIN_GENERATE_NEW_INVOICE_REQUEST,
  payload: { domainData, callBackFunction },
});

const domainsGenerateNewInvoiceSuccess = () => ({
  type: DomainsActionTypes.DOMAIN_GENERATE_NEW_INVOICE_SUCCESS,
});

const domainsGenerateNewInvoiceFailure = () => ({
  type: DomainsActionTypes.DOMAIN_GENERATE_NEW_INVOICE_FAILURE,
});

const domainsGenerateNewInvoiceLoading = value => ({
  type: DomainsActionTypes.DOMAIN_GENERATE_NEW_INVOICE_LOADING,
  value,
});

const getDomainPropagationStatusRequest = domainId => ({
  type: DomainsActionTypes.GET_DOMAIN_PROPAGATION_STATUS_REQUEST,
  payload: domainId,
});

const getDomainPropagationStatusSuccess = () => ({
  type: DomainsActionTypes.GET_DOMAIN_PROPAGATION_STATUS_SUCCESS,
});

const getDomainPropagationStatusFailure = () => ({
  type: DomainsActionTypes.GET_DOMAIN_PROPAGATION_STATUS_FAILURE,
});

const setDomainPropagationStatus = allStatus => ({
  type: DomainsActionTypes.SET_DOMAIN_PROPAGATION_STATUS,
  payload: allStatus,
});

const getConfiguredDomainStatusRequest = domain => ({
  type: DomainsActionTypes.GET_CONFIGURED_DOMAIN_STATUS_REQUEST,
  payload: domain,
});

const getConfiguredDomainStatusSuccess = () => ({
  type: DomainsActionTypes.GET_CONFIGURED_DOMAIN_STATUS_SUCCESS,
});

const getConfiguredDomainStatusFailure = () => ({
  type: DomainsActionTypes.GET_CONFIGURED_DOMAIN_STATUS_FAILURE,
});

const setConfiguredDomainStatus = data => ({
  type: DomainsActionTypes.SET_CONFIGURED_DOMAIN_STATUS,
  payload: {
    id: data.id,
    domain: data.domain,
    status: data.status,
  },
});

const setEmptyDomainStatus = () => ({
  type: DomainsActionTypes.SET_EMPTY_DOMAIN_STATUS,
});

const setResetDomainStatus = () => ({
  type: DomainsActionTypes.SET_RESET_DOMAIN_STATUS,
});

const setLoadedDomainStatus = () => ({
  type: DomainsActionTypes.SET_LOADED_CONFIGURED_DOMAIN_STATUS,
});

const setDomainsHasConfigured = id => ({
  type: DomainsActionTypes.SET_DOMAIN_HAS_CONFIGURED,
  payload: id,
});

const setDomainsHasConfiguredSuccess = () => ({
  type: DomainsActionTypes.SET_DOMAIN_HAS_CONFIGURED_SUCCESS,
});

const setDomainsHasConfiguredFailure = () => ({
  type: DomainsActionTypes.SET_DOMAIN_HAS_CONFIGURED_FAILURE,
});

const setDomainEPPRedirect = redirect => ({
  type: DomainsActionTypes.SET_DOMAIN_EPP_REDIRECT,
  payload: redirect,
});

const setModalEppKeyOpen = (domainName, domainId) => ({
  type: DomainsActionTypes.SET_MODAL_EPP_KEY_IS_OPEN,
  payload: {
    name: domainName,
    id: domainId,
  },
});

const setModalEppKeyClose = () => ({
  type: DomainsActionTypes.SET_MODAL_EPP_KEY_IS_CLOSED,
});

const setModalEppKeyChange = (domainName, domainId) => ({
  type: DomainsActionTypes.SET_MODAL_EPP_KEY_IS_CHANGED,
  payload: {
    name: domainName,
    id: domainId,
  },
});

const getEppKeyGeneratedRequest = (domainId, setModalStatus) => ({
  type: DomainsActionTypes.GET_EPP_KEY_GENERATED_REQUEST,
  payload: {
    domainId,
    setModalStatus,
  },
});

const getEppKeyGeneratedSuccess = () => ({
  type: DomainsActionTypes.GET_EPP_KEY_GENERATED_SUCCESS,
});

const getEppKeyGeneratedFailure = () => ({
  type: DomainsActionTypes.GET_EPP_KEY_GENERATED_FAILURE,
});

const setEppKeyGenerated = keyGenerated => ({
  type: DomainsActionTypes.SET_EPP_KEY_GENERATED,
  payload: keyGenerated,
});

const getAllDomainsListRequest = setModalStatus => ({
  type: DomainsActionTypes.GET_ALL_DOMAINS_LIST_REQUEST,
  payload: setModalStatus,
});

const getAllDomainsListSuccess = () => ({
  type: DomainsActionTypes.GET_ALL_DOMAINS_LIST_SUCCESS,
});

const getAllDomainsListFailure = () => ({
  type: DomainsActionTypes.GET_ALL_DOMAINS_LIST_FAILURE,
});

const setAllDomainsList = domainsList => ({
  type: DomainsActionTypes.SET_ALL_DOMAINS_LIST,
  payload: domainsList,
});

const requestChangeDomain = ({
  domain, hostingId, isAddonDomain, awaitForAppointment = false, domainId = null, isOnboarding = false, oldDomain, fallback,
}) => ({
  type: DomainsActionTypes.REQUEST_CHANGE_DOMAIN,
  payload: {
    domain,
    hostingId,
    isAddonDomain,
    isOnboarding,
    awaitForAppointment,
    domainId,
    oldDomain,
    fallback,
  },
});

const changeDomainSuccess = () => ({
  type: DomainsActionTypes.SUCCESS_CHANGE_DOMAIN,
});

const setNewDomain = domain => ({
  type: DomainsActionTypes.SET_NEW_DOMAIN,
  payload: { domain },
});

const resetChangeDomainState = () => ({
  type: DomainsActionTypes.RESET_CHANGE_DOMAIN_STATE,
});

const changeDomainFailure = code => ({
  type: DomainsActionTypes.FAILURE_CHANGE_DOMAIN,
  payload: code,
});

const changeDomainLoading = value => ({
  type: DomainsActionTypes.LOADING_CHANGE_DOMAIN,
  payload: value,
});

const setNewDomainOnboardingSummary = ({ hostingId, newDomain }) => ({
  type: DomainsActionTypes.SET_NEW_DOMAIN_ONBOARDING_SUMMARY,
  payload: { hostingId, newDomain },
});

const getTemporaryDomains = () => ({
  type: DomainsActionTypes.GET_TEMPORARY_DOMAINS,
});

const setTemporaryDomains = domains => ({
  type: DomainsActionTypes.SET_TEMPORARY_DOMAINS_LIST,
  payload: domains,
});

const setTemporaryDomainsLoadingStatus = bool => ({
  type: DomainsActionTypes.SET_TEMPORARY_DOMAINS_LOADING,
  payload: bool,
});

const getTemporaryDomainsSuccess = () => ({
  type: DomainsActionTypes.GET_TEMPORARY_DOMAINS_SUCCESS,
});

const getTemporaryDomainsFailure = () => ({
  type: DomainsActionTypes.GET_TEMPORARY_DOMAINS_FAILURE,
});

const getCreateTemporaryDomain = ({ hostingId }) => ({
  type: DomainsActionTypes.GET_CREATE_TEMPORARY_DOMAIN,
  payload: { hostingId },
});

const getCreateTemporaryDomainSuccess = () => ({
  type: DomainsActionTypes.GET_CREATE_TEMPORARY_DOMAIN_SUCCESS,
});

const getCreateTemporaryDomainFailure = () => ({
  type: DomainsActionTypes.GET_CREATE_TEMPORARY_DOMAIN_FAILURE,
});

const setCreateTemporaryDomainLoadingStatus = bool => ({
  type: DomainsActionTypes.SET_CREATE_TEMPORARY_DOMAIN_LOADING_STATUS,
  payload: bool,
});

const setTemporaryDomainCreated = domain => ({
  type: DomainsActionTypes.SET_TEMPORARY_DOMAIN_CREATED,
  payload: { domain },
});

const requestRedeemDomain = ({ redeemDomainsList, callbackFunc, onErrorCallbackfunc }) => ({
  type: DomainsActionTypes.REQUEST_REDEEM_DOMAIN,
  payload: { redeemDomainsList, callbackFunc, onErrorCallbackfunc },
});

const successRedeemDomain = () => ({ type: DomainsActionTypes.SUCCESS_REDEEM_DOMAIN });
const failureRedeemDomain = () => ({ type: DomainsActionTypes.FAILURE_REDEEM_DOMAIN });
const loadingRedeemDomain = isLoading => ({ type: DomainsActionTypes.LOADING_REDEEM_DOMAIN, payload: isLoading });
const resetRedeemDomain = () => ({ type: DomainsActionTypes.RESET_REDEEM_DOMAIN });

const getAvailableDomainTlds = ({ productId }) => ({
  type: DomainsActionTypes.GET_AVAILABLE_DOMAIN_TLDS,
  payload: { productId },
});

const availableDomainTldsSuccess = () => ({ type: DomainsActionTypes.AVAILABLE_DOMAIN_TLDS_SUCCESS });
const availableDomainTldsFailure = () => ({ type: DomainsActionTypes.AVAILABLE_DOMAIN_TLDS_FAILURE });

const setAvailableDomainTlds = ({ tldsResponse }) => ({
  type: DomainsActionTypes.SET_AVAILABLE_DOMAIN_TLDS,
  payload: { tldsResponse },
});

const loadingAvailableDomainTlds = isLoading => ({
  type: DomainsActionTypes.SET_AVAILABLE_DOMAIN_TLDS_LOADING,
  payload: isLoading,
});

const requestCheckDomainAvailability = ({
  sld, tld, isRadix,
}) => ({
  type: DomainsActionTypes.REQUEST_DOMAIN_AVAILABILITY,
  payload: {
    sld, tld, isRadix,
  },
});

const setDomainAvailability = ({
  currentDomain, isAvailable, tldsList, isRadix,
}) => ({
  type: DomainsActionTypes.SET_DOMAIN_AVAILABILITY,
  payload: {
    currentDomain, isAvailable, tldsList, isRadix,
  },
});

const domainAvailabilitySuccess = () => ({ type: DomainsActionTypes.DOMAIN_AVAILABILITY_SUCCESS });
const domainAvailabilityFailure = () => ({ type: DomainsActionTypes.DOMAIN_AVAILABILITY_FAILURE });

const resetDomainAvailability = () => ({ type: DomainsActionTypes.RESET_DOMAIN_AVAILABILITY });
const resetCurrentRadixDomainAvailability = () => ({ type: DomainsActionTypes.RESET_CURRENT_RADIX_DOMAIN_AVAILABILITY });

const loadingDomainAvailability = isLoading => ({
  type: DomainsActionTypes.LOADING_DOMAIN_AVAILABILITY,
  payload: isLoading,
});

const getCheckProvider = ({ numericDocument }) => ({
  type: DomainsActionTypes.REQUEST_CHECK_PROVIDER,
  payload: { numericDocument },
});

const checkProviderSuccess = () => ({ type: DomainsActionTypes.CHECK_PROVIDER_SUCCESS });
const checkProviderFailure = () => ({ type: DomainsActionTypes.CHECK_PROVIDER_FAILURE });
const resetCheckProvider = () => ({ type: DomainsActionTypes.RESET_CHECK_PROVIDER });

const setCheckProvider = ({ available }) => ({
  type: DomainsActionTypes.SET_CHECK_PROVIDER,
  payload: { available },
});

const setCheckProviderLoading = isLoading => ({
  type: DomainsActionTypes.SET_CHECK_PROVIDER_LOADING,
  payload: isLoading,
});

const getDomainRedeemAvailability = () => ({
  type: DomainsActionTypes.GET_DOMAINS_REDEEM_AVAILABILITY,
});

const setDomainRedeemAvailability = domains => ({
  type: DomainsActionTypes.SET_DOMAINS_REDEEM_AVAILABILITY,
  payload: domains,
});

const getDomainRedeemAvailabilitySuccess = () => ({
  type: DomainsActionTypes.GET_DOMAINS_REDEEM_AVAILABILITY_SUCCESS,
});

const getDomainRedeemAvailabilityFailure = () => ({
  type: DomainsActionTypes.GET_DOMAINS_REDEEM_AVAILABILITY_FAILURE,
});

const resetDomainRedeemAvailability = () => ({
  type: DomainsActionTypes.RESET_DOMAINS_REDEEM_AVAILABILITY,
});

const getDomainsToBuy = ({ tld, sld }) => ({
  type: DomainsActionTypes.GET_DOMAINS_TO_BUY_REQUEST,
  payload: { tld, sld },
});

const getDomainsToBuySuccess = ({ result }) => ({
  type: DomainsActionTypes.GET_DOMAINS_TO_BUY_SUCCESS,
  payload: { result },
});

const getDomainsToBuyFailure = () => ({
  type: DomainsActionTypes.GET_DOMAINS_TO_BUY_FAILURE,
});

const getDomainsToBuyLoading = isLoading => ({
  type: DomainsActionTypes.GET_DOMAINS_TO_BUY_LOADING,
  payload: isLoading,
});

const requestBuyDomain = ({ domains, redirectToInvoice }) => ({
  type: DomainsActionTypes.REQUEST_BUY_DOMAIN,
  payload: { domains, redirectToInvoice },
});

const loadingBuyDomain = isLoading => ({
  type: DomainsActionTypes.LOADING_BUY_DOMAIN,
  payload: isLoading,
});

const actions = {
  domains: {
    failure: getDomainsFailure,
    request: getDomainsRequest,
    success: getDomainsSuccess,
    set: setDomains,
    requestDetail: getDomainDetail,
    setDetail: setDomainDetail,
    detailSuccess: getDomainDetailSuccess,
    detailFailure: getDomainDetailFailure,
    activateRenewal: {
      request: domainsActivateRenewalRequest,
      success: domainsActivateRenewalSuccess,
      failure: domainsActivateRenewalFailure,
    },
    generateNewInvoice: {
      request: domainsGenerateNewInvoiceRequest,
      success: domainsGenerateNewInvoiceSuccess,
      failure: domainsGenerateNewInvoiceFailure,
      loading: domainsGenerateNewInvoiceLoading,
    },
  },
  propagationStatus: {
    get: getDomainPropagationStatusRequest,
    success: getDomainPropagationStatusSuccess,
    failure: getDomainPropagationStatusFailure,
    set: setDomainPropagationStatus,
  },
  configuredStatusDomain: {
    get: getConfiguredDomainStatusRequest,
    success: getConfiguredDomainStatusSuccess,
    failure: getConfiguredDomainStatusFailure,
    set: setConfiguredDomainStatus,
    empty: setEmptyDomainStatus,
    reset: setResetDomainStatus,
    loaded: setLoadedDomainStatus,
  },
  setDomainConfiguration: {
    set: setDomainsHasConfigured,
    success: setDomainsHasConfiguredSuccess,
    failure: setDomainsHasConfiguredFailure,
  },
  modalEppKey: {
    open: setModalEppKeyOpen,
    close: setModalEppKeyClose,
    change: setModalEppKeyChange,
    redirect: setDomainEPPRedirect,
    get: getEppKeyGeneratedRequest,
    set: setEppKeyGenerated,
    success: getEppKeyGeneratedSuccess,
    failure: getEppKeyGeneratedFailure,
  },
  activeDomainList: {
    get: getAllDomainsListRequest,
    set: setAllDomainsList,
    success: getAllDomainsListSuccess,
    failure: getAllDomainsListFailure,
  },
  domainsElegible: {
    get: getDomainsElegible,
    success: getDomainsElegibleSuccess,
    failure: getDomainsElegibleFailure,
    set: setDomainsElegible,
  },
  changeDomain: {
    request: requestChangeDomain,
    success: changeDomainSuccess,
    setNewDomain,
    resetState: resetChangeDomainState,
    failure: changeDomainFailure,
    loading: changeDomainLoading,
    setNewDomainOnboardingSummary,
  },
  temporaryDomains: {
    request: getTemporaryDomains,
    set: setTemporaryDomains,
    success: getTemporaryDomainsSuccess,
    failure: getTemporaryDomainsFailure,
    loading: setTemporaryDomainsLoadingStatus,
    creation: {
      request: getCreateTemporaryDomain,
      success: getCreateTemporaryDomainSuccess,
      failure: getCreateTemporaryDomainFailure,
      loading: setCreateTemporaryDomainLoadingStatus,
      set: setTemporaryDomainCreated,
    },
  },
  redeemDomain: {
    request: requestRedeemDomain,
    success: successRedeemDomain,
    failure: failureRedeemDomain,
    loading: loadingRedeemDomain,
    reset: resetRedeemDomain,
  },
  domainTlds: {
    request: getAvailableDomainTlds,
    success: availableDomainTldsSuccess,
    failure: availableDomainTldsFailure,
    set: setAvailableDomainTlds,
    loading: loadingAvailableDomainTlds,
  },
  domainAvailability: {
    request: requestCheckDomainAvailability,
    set: setDomainAvailability,
    success: domainAvailabilitySuccess,
    failure: domainAvailabilityFailure,
    loading: loadingDomainAvailability,
    resetCurrentRadix: resetCurrentRadixDomainAvailability,
    reset: resetDomainAvailability,
  },
  checkProvider: {
    request: getCheckProvider,
    set: setCheckProvider,
    success: checkProviderSuccess,
    failure: checkProviderFailure,
    loading: setCheckProviderLoading,
    reset: resetCheckProvider,
  },
  redeemAvailability: {
    request: getDomainRedeemAvailability,
    set: setDomainRedeemAvailability,
    success: getDomainRedeemAvailabilitySuccess,
    failure: getDomainRedeemAvailabilityFailure,
    reset: resetDomainRedeemAvailability,
  },
  buyDomain: {
    search: {
      request: getDomainsToBuy,
      success: getDomainsToBuySuccess,
      failure: getDomainsToBuyFailure,
      loading: getDomainsToBuyLoading,
    },
    requestBuyDomain,
    loadingBuyDomain,
  },
};

export default actions;
